import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {StripeAddCardComponent} from './stripe-add-card.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ButtonModule} from '@ucx/ui-cmp';
import {SpinnerButtonModule} from '../../../shared/modules/spinner-button/spinner-button.module';
import {TooltipModule} from '../../../shared/modules/tooltip/tooltip.module';
import {NgxStripeModule} from 'ngx-stripe';

@NgModule({
    declarations: [
        StripeAddCardComponent,
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        ButtonModule,
        TooltipModule,
        NgxStripeModule
    ],
    providers: [],
    exports: [
        StripeAddCardComponent
    ]
})

export class StripeAddCardModule {
}
